import React from 'react';
import SliderView from './SliderView';

const ComponentSlider = (props) => {
  const { components } = props

  return (
    <SliderView
      components={components}
      isMultiRow={true}
      activeOverlayMenu={false} />
  )
}

export default ComponentSlider;